import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function ClockIcon({
  className,
  color = "currentColor",
  size,
}: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className}>
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
      <path
        d="M12 7V11.5443C12 12.2562 12.2531 12.9449 12.7142 13.4873L14 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
}
